import { atom, atomFamily } from "recoil";
import { selector, selectorFamily } from "./recoilSelectors";
import { ReadableSequence } from "../types/sequence";
import { Job } from "../types/job";

export const sequenceState = atomFamily<ReadableSequence | undefined, string>({
    key: 'sequence',
    default: undefined,
});

export const sequenceIdsState = atom<string[]>({ key: "sequence.ids", default: [] });

export const sequencesState = selector({
    key: "sequences.all",
    get: ({ get }) => {
        return get(sequenceIdsState)
            .map(id => get(sequenceState(id)))
            .filter(seq => !!seq) as ReadableSequence[];
    }
});

export const sequenceFilterState = atom<string>({
   key: "sequences.filter",
   default: "",
});

export const sequenceJobsDispatchState = atomFamily<Job[], string>({
    key: 'sequence.dispatch',
    default: selectorFamily({
        key: 'sequence.dispatch.initializer',
        get: (id) => ({ get }) => {
            return get(sequenceState(id))?.jobs || [];
        }
    }),
});

export const loadingSequencesState = atom<boolean>({ key: "sequences.loading", default: false });

/** True once the routes were loaded at least once, so an empty list means there are none rather than not yet. */
export const sequencesLoadedState = atom<boolean>({ key: "sequences.loaded", default: false });